import { combineReducers } from 'redux';
import { userIdentificationsReducer } from './reducers/user-identifications-reducer';
import { applicationsListReducer } from './reducers/applications-list-reducer';
import { clientScopesReducer } from './reducers/client-scopes-reducer';
import { apiKeysListReducer } from './reducers/api-keys-list-reducer';

export default combineReducers({
  userIdentificationsReducer,
  applicationsListReducer,
  clientScopesReducer,
  apiKeysListReducer,
});
